/**
 * @ngdoc object
 * @name bo.objects.controller:BoOptionsListController
 *
 * @description
 *
 */

class BoOptionsListController {

    constructor(BoOptions, $state, NavHelper, $stateParams, $http, Alert) {
        this.state = $state;
        this.stateParams = $stateParams;
        this.navHelper = NavHelper;
        this.api = $http;
        this.alert = Alert;

        this.store = BoOptions.reset({
            listview: `BoObject${this.stateParams.objectId}Options`
        });
        this.store.commit('setPrefix', `bo/objects/${this.stateParams.objectId}`);
        this.store.commit('setSlug', `options`);
        this.store.commit('setVm', this);
        this.store.dispatch('loadWorkflows', 'bookable_objects::options-list');

        this._loadObject().then(() => {
            this._updateNavigation();
        });
        console.log(this.store.state.actions);
        console.log(this.store.state.vm);
    }

    _loadObject() {
        return this.api.get(`bo/objects/${this.stateParams.objectId}`).then((response) => {
            this.objectModel = response.data.data;
            this._updateNavigation();
        }, () => {
            this.alert.error('Error', 'Error while loading bookable object');
        });
    }

    _updateNavigation() {
        if (!this.objectModel) {
            return;
        }

        this.navHelper.setTranslationsParamsForEntry('settings.custom_defaults.bo-objects.details.main', {
            name: this.objectModel.label
        });
    }

    openOptionDetails(action, store) {
        this.state.go('app.bo.options.details', {
            objectId: this.objectModel.id,
            id: action.row.id
        });
    }

    addNewOption() {
        console.log('new option');
        this.state.go('app.bo.options.create', {
            objectId: this.objectModel.id
        });
    }
}

BoOptionsListController.$inject = [
    'BoOptions',
    '$state',
    'NavHelper',
    '$stateParams',
    '$http',
    'Alert'
];

angular
    .module('festzelt-os.modules.bo.objects')
    .controller('BoOptionsListController', BoOptionsListController);



// WEBPACK FOOTER //
// ./src/app/modules/bo/options/controllers/list-controller.js